import { keltnerLookback } from '../../math/lookback'
import { COLOR, float, line, matype, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'KELTNER',
  version: 1,
  label: 'Keltner Channels',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 43,
  // TradingView's defaults: EMA(20) ± 2 · ATR(10).
  inputs: [period('timeperiod', 20), matype('matype', 1), float('multiplier', 2, 'Multiplier', 0, 100, 0.1), period('atrperiod', 10, 'ATR length', 1)],
  outputs: [line('upper', 'Upper', COLOR.purple), line('basis', 'Basis', COLOR.orange), line('lower', 'Lower', COLOR.purple)],
  talib: {
    functions: ['MA', 'ATR'],
    expr: {
      upper: 'MA(close, timeperiod={timeperiod}, matype={matype}) + {multiplier} * ATR(high, low, close, timeperiod={atrperiod})',
      basis: 'MA(close, timeperiod={timeperiod}, matype={matype})',
      lower: 'MA(close, timeperiod={timeperiod}, matype={matype}) - {multiplier} * ATR(high, low, close, timeperiod={atrperiod})',
    },
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, matype, atrperiod }) => keltnerLookback(timeperiod, matype, atrperiod),
}
export default def
